import classNames from 'clsx';
import { ReactComponent as Arrow } from 'img/nestleLanding/ArrowMobileTimeline.svg';
import React, { memo } from 'react';
import { useDetectKeyboardOpen } from 'reactApp/hooks/useDetectKeyboardOpen';
import { useActiveSteps } from 'reactApp/sections/Nestle/hooks/useActiveSteps';

import styles from './TimelineMobile.css';

const steps = [1, 2, 3, 4];

export const TimelineMobile = memo(() => {
    const activeSteps = useActiveSteps();
    const isKeyboardOpen = useDetectKeyboardOpen();

    return (
        <div
            className={classNames(styles.root, {
                [styles.rootHidden]: isKeyboardOpen || !activeSteps.length || activeSteps.length === 4,
            })}
        >
            <div className={styles.wrapper}>
                {steps.map((step, index) => (
                    <div key={step} className={styles.stepBlock}>
                        <div
                            className={classNames(styles.circle, {
                                [styles.circleActive]: activeSteps.includes(step),
                            })}
                        >
                            {step}
                        </div>

                        {index !== steps.length - 1 && (
                            <div className={styles.line}>
                                <Arrow />
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
});

TimelineMobile.displayName = 'TimelineMobile';
